import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Trash2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const readFile = (file) =>
  new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });

export const LogoUploader = ({ endpoint, value, onSaved, testid = "logo", hint = "PNG o JPG, massimo 280 KB" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const save = async (logo) => {
    setBusy(true);
    try {
      await api.put(endpoint, { logo });
      toast.success(logo ? "Logo aggiornato" : "Logo rimosso");
      onSaved?.(logo);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  const pick = async (file) => {
    if (!file) return;
    if (!["image/png", "image/jpeg"].includes(file.type)) return toast.error("Usa un'immagine PNG o JPG");
    if (file.size > 280 * 1024) return toast.error("Logo troppo grande (massimo 280 KB)");
    await save(await readFile(file));
    if (ref.current) ref.current.value = "";
  };

  return (
    <div className="flex items-center gap-4" data-testid={`${testid}-uploader`}>
      <div className="flex h-16 w-28 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-dashed border-slate-300 bg-slate-50">
        {value ? <img data-testid={`${testid}-preview`} src={value} alt="Logo" className="max-h-14 max-w-[104px] object-contain" /> : <ImagePlus className="h-5 w-5 text-slate-400" />}
      </div>
      <div className="space-y-1.5">
        <div className="flex gap-2">
          <Button size="sm" variant="outline" disabled={busy} data-testid={`${testid}-upload-button`} onClick={() => ref.current?.click()}>
            {value ? "Cambia logo" : "Carica logo"}
          </Button>
          {value && (
            <Button size="sm" variant="ghost" disabled={busy} data-testid={`${testid}-remove-button`} className="text-rose-600" onClick={() => save(null)}>
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </div>
        <div className="text-xs text-slate-500">{hint}</div>
        <input ref={ref} data-testid={`${testid}-file-input`} type="file" accept="image/png,image/jpeg" className="hidden" onChange={(e) => pick(e.target.files?.[0])} />
      </div>
    </div>
  );
};

export const BrandMark = ({ logo, className = "" }) => (
  <img src={logo || "/fatturapro-logo.png"} alt="FatturazioneGestionale" data-testid="brand-logo" className={`max-h-10 max-w-full object-contain ${className}`} />
);
